module.exports = __webpack_public_path__ + "img/inbox-unarchive-fill.e98d77a6.svg";